// =============================================================================
// ImageToolsSettingsTab
// =============================================================================
// Hosts the AI image-tool platform settings. Future AI surfaces (mockup
// generator, text-to-image) ride the same job rails and will slot in as
// sibling panels here.
// =============================================================================

import { ImageToolsPanel } from './ImageToolsPanel';

export function ImageToolsSettingsTab() {
  return (
    <div className="space-y-6">
      <ImageToolsPanel />
    </div>
  );
}
